import PropTypes from "prop-types";
import CmsImageLoader from "@/base/CmsImageLoader";
import Video from "@/base/Video";
import {ButtonPill} from "@/base";

const ColumnedMedia = ({entity, image_size, text_theme, image, video }) => {

    const size = image_size?.value === 'standard' ? '770px' : '660px';

    const textDarkColor = {
        color: '#000',
        textShadow: "0 0 1.5rem rgb(255 255 255 / 80%)"
    };

    const textLightColor = {
        color: '#fff',
        textShadow: "0 0 1.5rem rgb(0 0 0 / 80%)"
    };

    const textOptions = [text_theme?.value === "light" ? textLightColor : textDarkColor];

    const getBackground = () => {

        if(video?.video_id?.value){
            return (
                <Video video_id={video.video_id.value} video_provider={video.video_provider.value} autoplay={true} background={true}/>
            )
        }

        if(image?.image_url?.value){
            return (
                <CmsImageLoader
                    css={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute" }}
                    url={image.image_url.value} alt={image.image_alt?.value}/>
            )
        }
    }

    const getColumns = () => {

        // find our columns array in the entity
        let columns = entity.value.elements.find((el)=>el.render_name==='columns');

        // for each column
        return columns?.value?.elements.map((column)=>{

            // determine what elements to display
            let elements = column.value.elements.map((colEl)=>{

                if(colEl.render_name === 'basic_html'){
                    return <div css={textOptions} className={'text-center'} key={`basic_html_${colEl.id}`} dangerouslySetInnerHTML={{__html:colEl.value}}/>
                }

                if(colEl.render_name === 'button'){

                    let buttonUrl = colEl.value.elements.find(subEl=>subEl.render_name==='button_url');
                    let buttonText = colEl.value.elements.find(subEl=>subEl.render_name==='button_text');
                    let buttonTheme = colEl.value.elements.find(subEl=>subEl.render_name==='button_theme');

                    return (
                        <div className={'text-center'} key={`button_${colEl.id}`}>
                            <ButtonPill className={'mx-auto'} to={buttonUrl.value}
                                        buttonTheme={buttonTheme.value}>{buttonText.value}</ButtonPill>
                        </div>
                    )
                }
            })

            return (
                <div key={column.id} className={'size-full size-md-1of3 px-2 px-sm-4 mb-4 mb-md-0'}>{elements}</div>
            )
        })
    }

    const overlayCss = {
        height: '100%',
        width: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 55.21%, rgba(0, 0, 0, 0.48) 73.96%)'
    }

    return (
        <div data-aos="fade-in" data-aos-delay={200}
             css={{position: "relative", overflow: "hidden", minHeight: size}}
                className={'d-flex align-items-center align-items-md-end'}>

            {getBackground()}

            <div css={overlayCss}/>

            <div className={'posRelative size-full p-4 p-lg-6 d-flex flex-row justify-content-center flex-wrap'} >

                {getColumns()}

            </div>

        </div>
    );
};

ColumnedMedia.propTypes = {
    entity: PropTypes.object,
    image_size: PropTypes.object,
    text_theme: PropTypes.object,
    image: PropTypes.object,
    video: PropTypes.object
};

export default ColumnedMedia;
